import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/vacation-graphics',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/settings/vacation-graphics/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/settings/vacation-graphics/${id}`,
      method: 'get'
  })
}
export function getStaffInfo(id) {
  return request({
      url: `/settings/vacation-management/staff/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/vacation-graphics',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/vacation-graphics/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/vacation-graphics/${id}`,
      method: 'delete',
  })
}
